// extracted by mini-css-extract-plugin
export default {"card":"style_card__r8pPZ","noMargin":"style_noMargin__X7TuZ"};